$_CLASS: '.joy-tab';

#{$_CLASS}:not(#{$_CLASS}__selected) {
    display: none !important;
}

#{$_CLASS}__selected {
    display: block;
    margin-top: var(--joy-core-spacing-9);
}

:host {
    font-family: var(--joy-font-family);
}
